import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Button,
  DialogActions,
  Typography,
  Alert,
} from "@mui/material";

const styles = {
  container: {
    display: "block",
  },
  content: {
    paddingY: 0,
  },
  actions: {
    paddingTop: 0,
    paddingRight: "1rem",
  },
};

const ConfirmationDialog = (props) => {
  const {
    open,
    onClose,
    onConfirm,
    title,
    message,
    confirmText = "Aceptar",
    cancelText = "Cancelar",
  } = props;

  const handleClose = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Alert severity="warning" sx={{ fontWeight: "bold", fontSize: "24" }}>
          {title}
        </Alert>
      </DialogTitle>
      <DialogContent sx={styles.content}>
        <Box sx={styles.container}>
          <Typography>{message}</Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={styles.actions}>
        <Button variant="contained" color="error" onClick={onConfirm}>
          {confirmText}
        </Button>
        <Button variant="text" onClick={handleClose}>
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
